export interface StravaSettings {
  autoUpload: boolean;
  autoUploadPhoto: boolean;
}

const STRAVA_SETTINGS_KEY = 'strava_settings';

export const defaultStravaSettings: StravaSettings = {
  autoUpload: true,
  autoUploadPhoto: true,
};

export function getStravaSettings(): StravaSettings {
  try {
    const stored = localStorage.getItem(STRAVA_SETTINGS_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return {
        autoUpload: parsed.autoUpload !== undefined ? parsed.autoUpload : defaultStravaSettings.autoUpload,
        autoUploadPhoto: parsed.autoUploadPhoto !== undefined ? parsed.autoUploadPhoto : defaultStravaSettings.autoUploadPhoto,
      };
    }
  } catch (error) {
    console.warn('Failed to parse Strava settings:', error);
  }
  return defaultStravaSettings;
}

export function updateStravaSettings(settings: Partial<StravaSettings>): StravaSettings {
  const currentSettings = getStravaSettings();
  const newSettings = { ...currentSettings, ...settings };
  
  try {
    localStorage.setItem(STRAVA_SETTINGS_KEY, JSON.stringify(newSettings));
  } catch (error) {
    console.warn('Failed to save Strava settings:', error);
  }
  
  return newSettings;
}

export function clearStravaSettings(): void {
  try {
    localStorage.removeItem(STRAVA_SETTINGS_KEY);
  } catch (error) {
    console.warn('Failed to clear Strava settings:', error);
  }
}